
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTrackEvent } from "../hooks/useTrackEvent/useTrackEvent";
import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { Button } from "../components/Shared/Button";
import { ResponsiveLayout } from "../components/Shared/ResponsiveLayout";
import useBrandConfig from "../hooks/useBrandConfig";
import { t } from "i18next";
import { QueryString } from "../constants/queryString";
import { useVerifyCode } from "../hooks/useVerifyCode";
import { CarPollingSource, sendAccessCode } from "../apis/energyNetApi";
import { useAuth } from "../hooks/useAuth/useAuth";
import * as querystring from 'querystring';
import { Console } from "console";

export const AddEVSE = () => {
    const navigate = useNavigate();
    const [waiting, setWaiting] = useState(false);
    const trackEvent = useTrackEvent();
    const config = useBrandConfig();
    const [isOpen, setIsOpen] = useState(false);
    const [verifier, setVerifyCode] = useVerifyCode();
    const [searchParams] = useSearchParams();
    const { user, email } = useAuth();

    const fromDashboard = searchParams.get(QueryString.SignUp) === null;
    const testMode = true;

    const handleContinueClick = () => {
        // don't set the sign up step to addvehicle to simplify the logic in the UnauthenticatedLayout.
        // we'll just return here if someone happens to abort from addvehicle, no big deal.
        navigate(`/addvehicle?${QueryString.SignUp}`);
    };

    const location = useLocation();
    //const emporiaRedirectUrl = "http://localhost:3000/addevse";
    const emporiaRedirectUrl = "https://vec.flexcharging.com/addevse";

    /* Redirect URL handling */
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');
        const state = urlParams.get("state");

        if (error) {
            trackEvent("EmporiaSignupError", { error });
            return;
        }

        if (user && code && email) {
            //alert(`${code}/${email}/${state}/${user}/${testMode}`);

            sendAccessCode(user, code, "Emporia", emporiaRedirectUrl, testMode, verifier, CarPollingSource.Emporia)
                .then(() => {
                    trackEvent("SendAccessCodeSuccess", { emporiaRedirectUrl });

                    //alert('Success : EVSE successfully added');

                    if (state) {
                        // this is a signup flow - go to location instructions
                        navigate(`/addlocation?${QueryString.SignUp}`);
                    }
                    else {
                        navigate("/dashboard", { replace: true });
                    }
                    setWaiting(false);
                })
                .catch((error) => {
                    setWaiting(false);
                    //alert(`Error adding EVSE: ${error.message}`);
                });
        }

        /* Perform action with the 'id' parameter */
        console.log('Resource ID:', code);

        // Example: Fetch data based on the ID
        // fetch(`/api/resources/${id}`).then(...);
    }, [setVerifyCode, emporiaRedirectUrl, testMode, user, verifier, trackEvent]);

    const getEmporiaLoginUrlForBrowser = async (state: string) => {

        const clientId = '7ss6sjfham0r78s6n6kk622d1j';
        const clientBaseAddress = 'https://auth.emporiaenergy.com/';
        //const redirectUri = `${window.location.protocol}/addevse`;
        //const redirectUri = 'http://localhost:3000/addevse';
        const redirectUri = 'https://vec.flexcharging.com/addevse';
        //const redirectUri = 'https://oauth.pstmn.io/v1/callback';
        const scopes = 'openid profile aws.cognito.signin.user.admin';

        const uriBuilder = new URL(clientBaseAddress + 'oauth2/authorize');
        uriBuilder.port = '';

        const queryParams = {
            client_id: clientId,
            redirect_uri: redirectUri,
            response_type: 'code',
            scope: scopes,
            //state: config.programName,
            state: "VEC",
            locale: navigator.language || "en-US",
        };

        uriBuilder.search = querystring.stringify(queryParams);

        return {
            url: uriBuilder.toString(),
        };
    }

    const openEmporiaDialog = useCallback(async () => {
        const { url } = await getEmporiaLoginUrlForBrowser(fromDashboard ? "" : "signup"); 
        // need to save this verifier so we can use it to trade for an access token
        trackEvent("EmporiaStarted");
        window.location.href = url;
    }, [setVerifyCode, trackEvent]);

    return (
        <ResponsiveLayout>
            <>
                <h2 className={"text-4xl md:text-5xl font-sans-bold"}>
                    {config.addEVSEHeader}
                </h2>
                <p className={"text-lg mt-[40px] md:mt-[20px]"}>
                    {config.addEVSEInstructions}
                </p>
                <hr className={"border-default mt-[20px] mb-[10px]"} />

                <div className={"mt-[60px] pb-[20px] flex justify-center"}>
                    <Button
                        variant="primary"
                        text={t('Emporia Charger')}
                        onClick={openEmporiaDialog}
                    />
                </div>
            </>
        </ResponsiveLayout>
    );
};
